import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    token_type: '',
    token_expires_at: localStorage.getItem('token_expires_at')  ? JSON.parse(localStorage.getItem('token_expires_at')) : '',
    scope: '',
    avatar: '',
    username: localStorage.getItem('username')  ? localStorage.getItem('username') : '',
    over18: false,
    loginState: {},
    adminUser: localStorage.getItem('admin_user')  ? JSON.parse(localStorage.getItem('admin_user')) : null
  },
  mutations: {
      auth_request(state){
          state.status = 'loading'
      },
      auth_success(state, user){
          state.status = 'success'
          state.token = user.access_token
          state.token_type = user.token_type
          state.token_expires_at = user.expires_in
          state.scope = user.scope
          state.username = user.username
          state.avatar = user.avatar
          //state.refresh_token = user.refresh_token
      },
      set_admin_user(state, data) {
          state.adminUser = data;
          localStorage.setItem('admin_user', JSON.stringify(data))
      },
      auth_error(state){
          state.status = 'error'
      },
      logout(state){
          state.status = ''
          state.token = ''
          state.token_expires_at = ''
          state.adminUser = {}
      },
      acceptOver18(state) {
          state.over18 = true;
      },
      updateLoginStatePayload(state, payload) {
          state.loginState = payload
      }
  },
  actions: {
    login({commit}, {user: user, vm: vm}){
        localStorage.setItem('token', user.access_token)
        let token_expires_at = Date.now() + 3600000;
        user.expires_in = token_expires_at;
        localStorage.setItem('token_expires_at', JSON.stringify(token_expires_at))
        localStorage.setItem('username', user.username)
        vm.$redditApi.defaults.headers.common['Authorization'] = `Bearer ${user.access_token}`;
        commit('auth_success', user)
    },
      logout({commit}, vm){
        console.log('Running logout')
          // eslint-disable-next-line no-unused-vars
          return new Promise((resolve, reject) => {
              commit('logout');
              localStorage.removeItem('token');
              localStorage.removeItem('token_expires_at');
              localStorage.removeItem('username');
              localStorage.removeItem('admin_user');
              delete vm.$redditApi.defaults.headers.common['Authorization']
              resolve()
          })
      },
    set_admin_data({commit}, data) {
        commit('set_admin_user', data)
    }
  },
  getters: {
      isLoggedIn: state => {
          if (!state.token)
              return false;
          return state.token_expires_at > Date.now();

      },
      authStatus: state => state.status,
      token: state => state.token,
      avatar: state => state.avatar,
      username: state => state.username,
      over18: state => state.over18,
      adminUser: state => state.adminUser,
  },
  modules: {
  }
})
